import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=8c1c2c16"
import script from "./Place.vue?vue&type=script&lang=ts"
export * from "./Place.vue?vue&type=script&lang=ts"
import style0 from "./Place.vue?vue&type=style&index=0&id=8c1c2c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports